module.exports = __webpack_public_path__ + "img/management-practitioner.627d7ab1.svg";